import { isEmpty } from 'lodash';
import { environment } from 'environments/environment';

export function serializeUrl(obj: any, parent = ''): string {
    let result: any = "";
    for (const key in obj) {
      const value = obj[key];
      let temp = '';
      if (!value) continue;
      
      const prefix = parent.length > 0 ? `${parent}[${key}]` : key;
      if (value instanceof Array || value instanceof Object) {
        if (isEmpty(value)) continue;
        temp = `${serializeUrl(obj[key], prefix)}<SEPARATOR>`;
      } else {
        temp = `${prefix}=${obj[key]}<SEPARATOR>`
      }

      if (!isEmpty(temp)) result += temp;
    }

    return !isEmpty(parent) ? result :
      result
        .split("<SEPARATOR>")
        .filter(item => !isEmpty(item))
        .join('&');

}

export function composeUrl(url: string, params: any = {}): string {
  const slash = url.charAt(0) == "/" ? "" : "/";
  const args = isEmpty(params) ? "" : `?${serializeUrl(params)}`;
  return `${environment.apiURL}${slash}${url}${args}`
}

function buildFormData(formData, data, parentKey = null) {
  if (data == undefined) return;

  const notPrimitive = typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)
  if (notPrimitive) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
    return;
  }
  
  formData.append(parentKey, data);

}

export function toFormData(obj: any) {
  const formData = new FormData();

  buildFormData(formData, obj);

  return formData;
}
